import { ReportMetadataResponse, status } from "../../../client/types.gen";

type SharePremiumFields = Pick<
  ReportMetadataResponse,
  "status" | "share_premium"
>;

// The backend computes a share premium for every report, but the dashboard
// shows it only for quoted and bound (including issued) deals.
const SHARE_PREMIUM_STATUSES: status[] = ["quoted", "bound", "issued"];

export const displayedSharePremium = (
  report: SharePremiumFields
): number | null =>
  SHARE_PREMIUM_STATUSES.includes(report.status) ? report.share_premium : null;

// Sort key for the Share Prem column. Reports that show no premium sort first
// ascending and last descending.
export const sharePremiumSortValue = (report: SharePremiumFields): number =>
  displayedSharePremium(report) ?? Number.NEGATIVE_INFINITY;
